import React, {PropsWithChildren, useEffect, useState} from "react";
import {Theme, ThemeProvider} from "@material-ui/core/styles";
import {ABCTheme, CargoPartnerTheme, VCPTheme} from "./DomainThemes";
import {DOMAINS} from "../../constants/DomainUrlConstants";
import BackendRestClient, {HEADER_DOMAIN_KEY} from "../../api/BackendRestClient";

function setHeader(domain) {
    BackendRestClient.interceptors.request.use(config => {
        config.headers[HEADER_DOMAIN_KEY] = domain;
        return config;
    }, error => Promise.reject(error));
}

const CustomTheme: React.FC<PropsWithChildren> = ({children}) => {
    const [theme, setTheme] = useState<Theme>(CargoPartnerTheme);

    useEffect(() => {
        const setApplicationSkin = () => {


            if (window.location.hostname.includes(DOMAINS.ABC.url)) {
                setTheme(ABCTheme);
                setHeader(DOMAINS.ABC.domain);

            } else if (window.location.hostname.includes(DOMAINS.VCP.url)) {
                setTheme(VCPTheme);
                setHeader(DOMAINS.VCP.domain);
            } else {
                setTheme(CargoPartnerTheme);
                setHeader(DOMAINS.CP.domain);
            }


        };

        if (typeof window !== 'undefined') {
            setApplicationSkin();
        }
    }, []);

    return (
        <ThemeProvider theme={theme}>
            {children}
        </ThemeProvider>
    );
};

export default CustomTheme;
